import React from 'react';

import { TiInfoLargeOutline } from 'react-icons/ti';
import { BsLinkedin } from 'react-icons/bs';
import { IoLogoGithub } from 'react-icons/io';
import { AiOutlineHome } from 'react-icons/ai';
import { FaLaptopCode } from 'react-icons/fa';
import { BiMessageDots } from 'react-icons/bi';
import { SiKnowledgebase } from 'react-icons/si';
import { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useContext } from 'react';
import { context } from '../../context/store';
import { NavHashLink } from 'react-router-hash-link';

const Navbar = (props) => {
  const [open, setOpen] = useState(false);
  const [left, setLeft] = useState('lg:left-[-10rem] left-[-5rem]');

  const { dispatch } = useContext(context);

  const OpenerCloser = () => {
    if (!open) {
      setOpen((prev) => !prev);

      dispatch({ type: 'OPENERCLOSER', open: true });
      setLeft('left-0');
    } else {
      setOpen((prev) => !prev);
      dispatch({ type: 'OPENERCLOSER', open: false });
      setLeft('lg:left-[-10rem] left-[-5rem]');
    }
  };
  const redirector = (e) => {
    // e.preventDefault();
    open && setLeft('lg:left-[-10rem] left-[-5rem]');
    setOpen(false);
    // OpenerCloser();
    // const portfolio = document.getElementById('portfolio');

    // portfolio.scrollIntoView();
  };
  return (
    <div className="relative">
      <NavLink to={'/'}>
        <div className=" fixed w-full h-[3rem] top-0 right-0 bg-slate-900 z-20 border-r border-b-2 border-teal-500 ">
          <div className="  left-[5.4rem]  fixed z-20">
            <h1
              className={`${
                open && 'lg:ml-[10rem]'
              } text-teal-400 font-vt tracking-wider text-4xl transition-all duration-[.5s] ease-in-out'
          }`}
            >
              Nisat Islam
            </h1>
          </div>
        </div>
      </NavLink>
      {/* <div
        className={`h-[3rem] w-full bg-gradient-to-tr from-slate-800
          to-slate-900 fixed z-10
         border-b-2 border-teal-400 transition-opacity duration-[.3s] ease-in  `}
      /> */}
      <div
        className={` fixed  border-teal-400 text-teal-400 block top-0  ${
          open
            ? ' pt-[15px]  lg:translate-x-[30px] translate-x-[20px]'
            : 'py-[7px]   translate-x-1 lg:translate-x-[20px]'
        } transition-transform duration-[.3s] ease-linear select-none focus:opacity-0 rounded-md z-50 cursor-pointer`}
        onClick={OpenerCloser}
      >
        <span
          className={`block   ${
            open
              ? 'w-9 bg-gradient-to-r from-teal-300 to-teal-400 translate-y-[0px] rotate-45'
              : 'bg-teal-400'
          } w-8 h-1 w rounded-md my-[5px] transition-[background-color,width,transform] ease-in duration-[.5s]  `}
        />
        <span
          className={`block mx-0 my-auto   ${
            open
              ? 'bg-gradient-to-r from-teal-300 to-teal-400 w-0'
              : 'bg-teal-400 w-8'
          }  h-1 rounded-md my-[5px] transition-[background-color,width,transform] ease-in duration-[.5s] `}
        />
        <span
          className={`block   ${
            open
              ? 'w-9 bg-gradient-to-r from-teal-300 to-teal-400 translate-y-[-18px] -rotate-45'
              : 'bg-teal-400'
          } w-8 h-1 rounded-md my-[5px] transition-[background-color,width,transform] ease-in duration-[.5s]  `}
        />
      </div>
      <nav
        className={`font-outfit fixed bg-gradient-to-r from-slate-800 to-slate-900 
          bottom-0 px-[3px]
           ${left} pt-11 top-0 
          transition-all duration-[.5s]
          ease-in-out lg:w-[15rem] w-[5rem] select-none  border-r-2 border-teal-500 z-40
          lg:text-base text-sm font-semibold
          `}
      >
        <NavHashLink to={'/#home'} onClick={redirector}>
          <li
            className={` lg:py-5 py-3 px-[30%] tracking-wide uppercase 
                relative transition-colors duration-[.3s,.15s]
                 ease-in text-teal-300 lg:font-semibold
                block
                 hover:bg-teal-400 hover:text-black  after:content-[''] 
                 after:absolute after:left-0 after:bottom-0 
                 after:h-full after:bg-teal-500 after:w-0 
                 after:transition-[width] after:duration-[.3s] after:ease-in after:-z-[1] 
               hover:after:w-full `}
          >
            <div className="flex active:text-slate-700 lg:flex-row flex-col-reverse">
              <p className="lg:translate-y-0 lg:translate-x-0 -translate-x-2 translate-y-1  ">
                Home
              </p>
              <AiOutlineHome
                className={`lg:absolute text-3xl ${
                  open ? 'lg:-translate-x-10' : 'lg:translate-x-[6.9rem]'
                } top-4 transition-transform duration-[.3s] ease-in`}
              />
            </div>
          </li>
        </NavHashLink>
        <NavLink to={'/about'} onClick={redirector}>
          <li
            className={` lg:py-5 py-3 px-[30%] tracking-wide uppercase 
            relative transition-colors duration-[.3s,.15s]
             ease-in text-teal-300 lg:font-semibold
            block
             hover:bg-teal-400 hover:text-black  after:content-[''] 
             after:absolute after:left-0 after:bottom-0 
             after:h-full after:bg-teal-500 after:w-0 
             after:transition-[width] after:duration-[.3s] after:ease-in after:-z-[1] 
           hover:after:w-full `}
          >
            <div className="flex active:text-slate-700 lg:flex-row flex-col-reverse">
              <p className="lg:translate-y-0 lg:translate-x-0 -translate-x-3 translate-y-1  ">
                About
              </p>
              <TiInfoLargeOutline
                className={`lg:absolute text-3xl ${
                  open ? 'lg:-translate-x-10' : 'lg:translate-x-[6.9rem]'
                } top-4 transition-transform duration-[.3s] ease-in`}
              />
            </div>
          </li>
        </NavLink>
        <NavHashLink to={'/#technologies'} onClick={redirector}>
          <li
            className={` lg:py-5 py-3 px-[30%] tracking-wide uppercase 
            relative transition-colors duration-[.3s,.15s]
             ease-in text-teal-300 lg:font-semibold
            block
             hover:bg-teal-400 hover:text-black  after:content-[''] 
             after:absolute after:left-0 after:bottom-0 
             after:h-full after:bg-teal-500 after:w-0 
             after:transition-[width] after:duration-[.3s] after:ease-in after:-z-[1] 
           hover:after:w-full `}
          >
            <div className="flex active:text-slate-700 lg:flex-row flex-col-reverse">
              <p className="lg:translate-y-0 lg:translate-x-0 -translate-x-3 translate-y-1  ">
                Skills
              </p>
              <SiKnowledgebase
                className={`lg:absolute text-3xl ${
                  open ? 'lg:-translate-x-10' : 'lg:translate-x-[6.9rem]'
                } top-4 transition-transform duration-[.3s] ease-in`}
              />
            </div>
          </li>
        </NavHashLink>
        <NavHashLink
          to={'/#portfolio'}
          onClick={redirector}
          className={` lg:py-5 py-3 px-[30%] tracking-wide uppercase 
          relative transition-colors duration-[.3s,.15s]
           ease-in text-teal-300 lg:font-semibold
          block
           hover:bg-teal-400 hover:text-black  after:content-[''] 
           after:absolute after:left-0 after:bottom-0 
           after:h-full after:bg-teal-500 after:w-0 
           after:transition-[width] after:duration-[.3s] after:ease-in after:-z-[1] 
         hover:after:w-full `}
        >
          {' '}
          <div className="flex active:text-slate-700 lg:flex-row flex-col-reverse">
            <p className="lg:translate-y-0 lg:translate-x-0 -translate-x-5 translate-y-1  ">
              Projects
            </p>
            <FaLaptopCode
              className={`lg:absolute text-3xl ${
                open ? 'lg:-translate-x-10' : 'lg:translate-x-[6.9rem]'
              } top-4 transition-transform duration-[.3s] ease-in`}
            />
          </div>
        </NavHashLink>{' '}
        <NavHashLink
          to={'/#contact'}
          onClick={redirector}
          className={` lg:py-5 py-3 px-[30%] tracking-wide uppercase 
          relative transition-colors duration-[.3s,.15s]
           ease-in text-teal-300 lg:font-semibold
          block
           hover:bg-teal-400 hover:text-black  after:content-[''] 
           after:absolute after:left-0 after:bottom-0 
           after:h-full after:bg-teal-500 after:w-0 
           after:transition-[width] after:duration-[.3s] after:ease-in after:-z-[1] 
         hover:after:w-full `}
        >
          <div className="flex active:text-slate-700 lg:flex-row flex-col-reverse">
            <p className="lg:translate-y-0 lg:translate-x-0 -translate-x-5 translate-y-1  ">
              Contact
            </p>
            <BiMessageDots
              className={`lg:absolute text-3xl ${
                open ? 'lg:-translate-x-10' : 'lg:translate-x-[6.9rem]'
              } top-4 transition-transform duration-[.3s] ease-in`}
            />
          </div>
        </NavHashLink>
        <a
          href="https://github.com/Nisat-islam"
          target="_blank"
          rel="noreferrer"
          className={` lg:py-5 py-3 px-[30%] tracking-wide uppercase 
          relative transition-colors duration-[.3s,.15s]
           ease-in text-teal-300 lg:font-semibold
          block
           hover:bg-teal-400 hover:text-black  after:content-[''] 
           after:absolute after:left-0 after:bottom-0 
           after:h-full after:bg-teal-500 after:w-0 
           after:transition-[width] after:duration-[.3s] after:ease-in after:-z-[1] 
         hover:after:w-full `}
        >
          <div className="flex active:text-slate-700 lg:flex-row flex-col-reverse">
            <p className="lg:translate-y-0 lg:translate-x-0 -translate-x-3 translate-y-1 ">
              Github
            </p>
            <IoLogoGithub
              className={`lg:absolute text-3xl ${
                open ? 'lg:-translate-x-10' : 'lg:translate-x-[6.9rem]'
              } top-4 transition-transform duration-[.3s] ease-in`}
            />
          </div>
        </a>
        <a
          href="https://www.linkedin.com/in/nisat-islam/"
          target="_blank"
          rel="noreferrer"
          className={` py-5 px-[30%] tracking-wide uppercase 
          relative transition-colors duration-[.3s,.15s]
           ease-in text-teal-300 lg:font-semibold
          block
           hover:bg-teal-400 hover:text-blue-600  after:content-[''] 
           after:absolute after:left-0 after:bottom-0 
           after:h-full after:bg-teal-500 after:w-0 
           after:transition-[width] after:duration-[.3s] after:ease-in after:-z-[1] 
         hover:after:w-full`}
        >
          <div className="flex active:text-slate-700 lg:flex-row flex-col-reverse">
            <p className="lg:translate-y-0 lg:translate-x-0 -translate-x-5 translate-y-1  ">
              LinkedIn
            </p>
            <BsLinkedin
              className={`lg:absolute text-3xl ${
                open ? 'lg:-translate-x-10' : 'lg:translate-x-[6.9rem]'
              } top-4 transition-transform duration-[.3s] ease-in`}
            />
          </div>
        </a>
      </nav>
      <main
        className={`${
          open && 'lg:ml-[10rem] ml-[5rem]'
        }  transition-all ease-in-out duration-[.5s]  w-full`}
      >
        {props.children}
      </main>
    </div>
  );
};

export default Navbar;
